import { render, staticRenderFns } from "./common_table.vue?vue&type=template&id=733d2b58&scoped=true&"
import script from "./common_table.vue?vue&type=script&lang=js&"
export * from "./common_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733d2b58",
  null
  
)

export default component.exports